import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { useLang, useT, useUI } from "../../lib/i18n";

export default function Footer({ content = {}, contactInfo = {}, pagesVisibility = {} }) {
  const lang = useLang();
  const t = useT();
  const ui = useUI();
  const isHidden = (k) => pagesVisibility[k] === false;

  const navItems = [
    { to: `/${lang}`, label: ui.home, key: "home" },
    { to: `/${lang}/services`, label: ui.services, key: "services" },
    { to: `/${lang}/galerie`, label: ui.gallery, key: "gallery" },
    { to: `/${lang}/tarifs`, label: lang === "fr" ? "Tarifs" : "Pricing", key: "pricing" },
    { to: `/${lang}/blog`, label: ui.blog, key: "blog" },
    { to: `/${lang}/a-propos`, label: ui.about, key: "about" },
    { to: `/${lang}/contact`, label: ui.contactNav, key: "contact" },
  ].filter((n) => !isHidden(n.key));

  return (
    <footer className="bg-[#2D2A26] text-[#FDFBF7] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-serif text-3xl mb-3">{content.brand || "Sarita's Photography"}</h3>
          <p className="text-[#FDFBF7]/60 max-w-xs">{t(content.tagline)}</p>
        </div>
        <div>
          <h4 className="overline mb-5 !text-[#C87A5E]">Navigation</h4>
          <ul className="space-y-2.5">
            {navItems.map((n) => (
              <li key={n.to}><Link to={n.to} className="link-underline text-[#FDFBF7]/80 hover:text-[#FDFBF7]">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5 !text-[#C87A5E]">{ui.contactLabel}</h4>
          <ul className="space-y-3 text-[#FDFBF7]/80">
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#C87A5E]" /> {contactInfo.email}</li>
            <li className="flex items-center gap-3"><MapPin size={16} className="text-[#C87A5E]" /> {t(contactInfo.location)}</li>
            <li className="flex items-center gap-3"><Instagram size={16} className="text-[#C87A5E]" /> {contactInfo.instagram}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#FDFBF7]/10 py-6 px-6 md:px-12 flex flex-col sm:flex-row items-center justify-center gap-3 text-xs text-[#FDFBF7]/40">
        <Link
          to="/admin/login"
          className="text-[#FDFBF7]/25 hover:text-[#C87A5E] transition tracking-wider uppercase"
          data-testid="footer-admin-link"
          aria-label="Administration"
        >
          ·
        </Link>
        <span>{t(content.copyright)}</span>
      </div>
    </footer>
  );
}
